<!--基本信息录入-->
<template>
   <div class="contentRight">
      <div class="inputList">
         <el-form ref="inputForm" :model="form" label-width="180px" label-suffix=":" :disabled="!canSave">
            <el-col :span="24" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="推荐单位" prop="recommend_unit" :rules="[{required: true, message: '必须录入', trigger: 'blur'}]" >
                  <el-select v-model="form.recommend_unit" filterable remote reserve-keyword
                             placeholder="请选择推荐单位"
                             style="width: 100%">
                     <el-option v-for="(item,i) in ddl.recomList" :key="item.value" :label="item.text"
                                :value="item.value">
                     </el-option>
                  </el-select>
               </el-form-item>
            </el-col>
            <el-col :span="24" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="工程名称" prop="engineering_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.engineering_name"/>
               </el-form-item>
            </el-col>
            <el-col :span="24" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="承建单位名称" prop="constructorMe"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.constructorMe" :disabled="true"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="项目负责人姓名" prop="pm_name"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.pm_name"/>
               </el-form-item>
            </el-col>
            <el-col :span="12" style="padding-left: 10px; padding-right: 30px;">
               <el-form-item label="项目负责人电话" prop="pm_phone"
                             :rules="[{required: true, message: '必须录入', trigger: 'blur'}]">
                  <el-input v-model="form.pm_phone"/>
               </el-form-item>
            </el-col>
         </el-form>
      </div>
      <div class="uploadBtn" v-if="isEdit" style="margin-top: 5px; margin-bottom: 5px;">
         <el-button type="primary" v-if="canSave" @click="_saveData">保存</el-button>
      </div>
   </div>
</template>

<script>
import {
   getApplyBasicInfo,
   postApplyBasicInfo
} from "@/api/modules/greenEngineerApply";
import {getCompanyInfoByLoginUser, getRecomCompany} from '@/api/modules/project'
import labelInput from '@/components/table/labelInput.vue'
import labelSelect from "@/components/table/labelSelect";
import ruiTool from "@/utils/ruiTool";
import {vaildte} from "@/utils/validate";

export default {
   data() {
      return {
         form: {
            opMode: '',
            project_application_id: '',
            id: '',
            engineering_name: '',
            construct_scale: '',
            structural_style: '',
            start_time: '',
            end_time: '',
            engineering_address: '',
            constructorMe: '',
            builder: '',
            designer: '',
            pm_name: '',
            pm_phone: '',
            constructor_linkman: '',
            constructor_linkphone: '',
            constructor_address: '',
            recommend_unit: ''
         },
         ddl: {
            /*推荐单位*/
            recomList: []
         },
         canSave: false,
         /*阶段数组*/
         stageArray: ['项目申报阶段', '地基与基础阶段', '主体结构阶段', '装饰装修与机电安装阶段', '竣工验收阶段', '证书制作阶段'],
      }
   },
   computed: {
      isEdit() {
         return this.form.opMode == 'edit';
      }
   },
   components: {
      labelInput,
      labelSelect
   },
   mounted() {
      //获取保存的传入参数
      this.form.project_application_id = localStorage.getItem("prjApplyCode")
      this.form.project_code = localStorage.getItem("prjCode");
      this.form.opMode = localStorage.getItem("opMode");

      //获取登录企业编号
      this.form.loginName = localStorage.getItem('loginName');
      this.form.company_code = localStorage.getItem('company_code');

      if (ruiTool.isNull(this.form.project_application_id)) {
         //新增模式
         this._getCompanyInfo();
         this._getRecomCompany();
         /*新增的时候，设置阶段控制数据*/
         localStorage.setItem('stage','项目申报阶段')
         localStorage.setItem('stageStatus','0');
      } else {
         /*修改模式，展示原数据*/
         getApplyBasicInfo({
            data: {prjApplyID: this.form.project_application_id},
            success: (res) => {
               //数据赋值
               Object.keys(res.data.item).forEach((key) => {
                  this.form[key] = res.data.item[key]
               })
               this._getRecomCompany();
            }
         })
      }

      /*根据阶段判断是否可以保存*/
      const stage = localStorage.getItem('stage');
      const stageStatus = localStorage.getItem('stageStatus');
      if (stage == '项目申报阶段' && stageStatus == '0' || stage == '项目申报阶段' && stageStatus == '8')
         this.canSave = true;
   },
   methods: {
      /*提交基本数据*/
      _saveData() {
         this.$refs['inputForm'].validate((valid) => {
            if (valid) {
               postApplyBasicInfo({
                  data: this.form,
                  success: (res) => {
                     Object.keys(res.data.item).forEach((key) => {
                        this.form[key] = res.data.item[key];
                     })
                     //保存申报单位信息
                     this.form.builder = this.form.constructorMe;
                     //将当前申报项目编号保存到本地存储
                     localStorage.setItem("prjApplyCode", this.form.project_application_id);
                     this.$message.success("保存成功");
                  }
               })
            } else {
               this.$message.error("存在未填写项");
            }
         })
      },
      /*根据登录账号获取企业默认信息*/
      async _getCompanyInfo() {
         let param = {loginUser: localStorage.getItem('loginName')};
         await getCompanyInfoByLoginUser({
            data: param,
            success: (res) => {
               console.log(res.data);
               //默认数据赋值 -- 承建单位名称
               this.form.constructorMe = res.data.item.name;
            }
         })
      },
      /*获取推荐单位*/
      async _getRecomCompany() {
         let param = {
            project_code: this.form.project_code,
            projectType: localStorage.getItem('projectType')
         }
         console.log('获取推荐单位1', param);
         await getRecomCompany({
            data: param,
            success: (res) => {
               this.ddl.recomList = res.data.ddl;
            }
         })
      },
      /*接收输入*/
      labelInput(e, name) {
         this.form[name] = e
      },
   }
}
</script>

<style scoped>
.contentRight {
   width: 100%;
}

/* 上传样式 */
.inputList {
   display: flex;
   flex-wrap: wrap;
   margin-top: 20px;
}
</style>